export const SEARCH_FOR_ESTHETICIANS = 'SEARCH_FOR_ESTHETICIANS';
export const GET_ESTIE_PROFILE = 'GET_ESTIE_PROFILE';
